import { all, put, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import Media from '../entities/Media'
import { REACT_APP_API_ENDPOINT } from '../endpoints';
function* getMedia(action) {
  try {
    yield put({ type: 'GET_MEDIA_REQUEST' })
    const result = yield new Promise((resolve, reject) => {
      axios.get(REACT_APP_API_ENDPOINT + '/media/' + action.id).then(response => {
        resolve({
          media: response.data
        })
      })
        .catch(error => {
          reject({
            code: error.response ? error.response.status : 404,
            msg: error.response ? error.response.data : 'Not Found'
          })
        })
    })
    const media = new Media({ ...result.media, code: 200 })
    yield put({
      type: 'GET_MEDIA_SUCCESS',
      response: {
        entities: {
          media: {
            [media.getId()]: media
          }
        }
      }
    })
  } catch (error) {
    const media = new Media({ id: action.id, code: error.code })
    yield put({
      type: 'GET_MEDIA_FAILURE',
      response: {
        entities: {
          media: {
            [media.getId()]: media
          }
        }
      }
    })
  }
}

function* watchGetMedia() {
  yield takeEvery('GET_MEDIA', getMedia)
}


export const mediaSaga = [
  watchGetMedia()
]

export default function* rootSaga() {
  yield all([
    ...mediaSaga
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/media.js